// App.js
import React from 'react';
import LoginForm from '../../Components/Outseta/Login';

const LoginOutseta = () => {
    return (
        <div className='welcome-body login-page left-0 !items-center !justify-around'>
            <LoginForm />
        </div>
    );
};

export default LoginOutseta;
